"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.citizenFormSchema = exports.citizenSchema = void 0;
const constants_1 = require("../constants");
const yup_lib_1 = __importDefault(require("../yup-lib"));
exports.citizenSchema = yup_lib_1.default.object().shape({
    account: yup_lib_1.default.string().required(),
    citizenPhoneNumber: yup_lib_1.default
        .string()
        .required()
        .matches(constants_1.US_PHONE_NUMBER_WITH_COUNTRY_CODE_REGEX, 'Phone number must be a valid US phone number with country code, e.g., 1234567890')
        .label('Phone Number'),
    categories: yup_lib_1.default.array().of(yup_lib_1.default.string().required()).notRequired(),
    language: yup_lib_1.default.string().required()
});
exports.citizenFormSchema = yup_lib_1.default.object().shape({
    account: yup_lib_1.default.string().required(),
    citizenPhoneNumber: yup_lib_1.default
        .string()
        .required()
        .matches(constants_1.US_PHONE_NUMBER_WITHOUT_COUNTRY_CODE_REGEX, 'Phone number must be a valid US phone number without country code, e.g., 1234567890')
        .label('Phone Number'),
    categories: yup_lib_1.default
        .array()
        .of(yup_lib_1.default.string().required())
        .min(1, 'Please select atleast one category')
        .label('Categories'),
    language: yup_lib_1.default.string().required()
});
